import { normalizeSpeciesKey, type ProductionSpeciesKey } from '../data/productionSpeciesPresets'

const SPECIES_NAME_TO_PRESET: Record<string, ProductionSpeciesKey> = {
  'Rainbow Trout': 'trout',
  'Nile Tilapia': 'tilapia',
  'Atlantic Salmon': 'salmon',
  'Pacific White Shrimp': 'shrimp'
}

const inferFromSpeciesNames = (names: unknown): ProductionSpeciesKey | null => {
  if (!Array.isArray(names)) return null
  for (const name of names) {
    if (typeof name !== 'string') continue
    const mapped = SPECIES_NAME_TO_PRESET[name]
    if (mapped) return mapped
  }
  return null
}

const inferFromCultureType = (cultureType: unknown): ProductionSpeciesKey | null => {
  if (typeof cultureType !== 'string') return null
  if (cultureType.trim().toLowerCase() === 'crustacean') return 'shrimp'
  return null
}

export const resolveFarmProductionSpeciesKey = (farm: unknown): ProductionSpeciesKey | null => {
  if (!farm || typeof farm !== 'object') return null

  const metadata = (farm as any).metadata
  if (metadata && typeof metadata === 'object') {
    const rawKey = (metadata as any).productionSpeciesKey
    if (typeof rawKey === 'string' && rawKey.trim().length > 0) {
      return normalizeSpeciesKey(rawKey)
    }

    const inferredFromSpecies = inferFromSpeciesNames((metadata as any).species)
    if (inferredFromSpecies) return inferredFromSpecies

    const inferredFromCultureType = inferFromCultureType((metadata as any).typeCulture)
    if (inferredFromCultureType) return inferredFromCultureType
  }

  const inferredFromTopLevelSpecies = inferFromSpeciesNames((farm as any).species)
  if (inferredFromTopLevelSpecies) return inferredFromTopLevelSpecies

  const inferredFromTopLevelCultureType = inferFromCultureType((farm as any).typeCulture)
  if (inferredFromTopLevelCultureType) return inferredFromTopLevelCultureType

  return null
}
